module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "logs"
    }
  }, [_c('md-content', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    attrs: {
      "md-theme": "white"
    }
  }, [_c('sort-table', {
    ref: "table",
    attrs: {
      "table-id": 'logs-list',
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.logsAmount,
      "showAddButton": false,
      "link": ""
    },
    on: {
      "refresh": _vm.getLogs
    },
    scopedSlots: _vm._u([{
      key: "user",
      fn: function(scope) {
        return _c('span', {}, [_vm._v(_vm._s((scope.item.user ? scope.item.user.fio + ' (' + scope.item.user.login + ')' : '')))])
      }
    }, {
      key: "module",
      fn: function(scope) {
        return _c('span', {}, [_vm._v(_vm._s(scope.item.module.description))])
      }
    }, {
      key: "action",
      fn: function(scope) {
        return _c('span', {}, [_vm._v(_vm._s(scope.item.action.name))])
      }
    }, {
      key: "entity_id",
      fn: function(scope) {
        return _c('span', {}, [_vm._v(_vm._s(scope.item.entity_id))])
      }
    }, {
      key: "actions",
      fn: function(scope) {
        return [_c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'trash'],
            "danger-light": "",
            "rounded": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.onRemove(scope.item.id)
            }
          }
        })]
      }
    }]),
    model: {
      value: (_vm.logs),
      callback: function($$v) {
        _vm.logs = $$v
      },
      expression: "logs"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e771bf1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/logs/views/Logs.vue
// module id = 1063
// module chunks = 0